import { PACDisclaimer } from "../../../../src/components/disclaimers";
import * as React from 'react';
export default {
  PACDisclaimer,
  React
};